import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrganizationContactResponse, OrganizationContactVO, OrganizationVO } from 'mds-ui/app/modules/common/master-data-setup/models/organizations';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OrganizationResponse, OrganizationSearch, OrganizationPriestSearch, SearchVO, OrganizationPriestSearchResponse } from '../models/organization.model';

@Injectable()
export class OrganizationService {
    dtformat = new DateTimeFormatPipe("en-US");
    public organizationSearch: OrganizationSearch;
    public organizationPriestSearch:OrganizationPriestSearch;
    public searchVO:SearchVO;
    public organizationContactVO : OrganizationContactVO;
    public contactType: string;
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    private handleError: HandleError;
    organizationList: any = [];
    organization: any;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('OrganizationService');
    }
    priestOrganizationInfoInit() {
        this.organizationPriestSearch = new OrganizationPriestSearch();
    }
    getAllOrganizationList(organizationSearch: OrganizationSearch): Observable<OrganizationResponse[]> {
        return this._http.post<OrganizationResponse[]>(
            environment.getAllOrganizationsListUrl, organizationSearch, this.httpOptions)
            .pipe(catchError(this.handleError('getAllOrganizationList', [])));
    }
    getBMOrganizationList(organizationSearch: OrganizationSearch): Observable<OrganizationResponse[]> {
        return this._http.post<OrganizationResponse[]>(
            environment.getBMOrganizationsListUrl, organizationSearch, this.httpOptions)
            .pipe(catchError(this.handleError('getBMOrganizationList', [])));
    }
    OrganizationSave(organization: OrganizationVO): Observable<OrganizationResponse[]> {
        return this._http.post<OrganizationResponse[]>(environment.postOrganizationURL, organization, this.httpOptions).pipe(
            catchError(this.handleError('OrganizationSave', [])));
    }
    DeleteOrganizationById(id: number, userName: string): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.deleteOrganizationById + id + "?username=" + userName + "&dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(catchError(this.handleError('DeleteOrganizationById', [])));
    }
    getOCAForOrganization(id: number,appId: number, userName: string): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.deleteOrganizationById + id + "/oca/app/"+appId+"?username=" + userName + "&dateParam=" + this.dtformat.transform(new Date, ""),
            this.httpOptions)

            .pipe(catchError(this.handleError('getOCAForOrganization', [])));
    }

    getOrganizationContactsById(id: number,appId: number, userName: string): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.getOrganizationContactsByIdURL + id + "?appId="+appId+"&userName=" + userName,
            this.httpOptions)
            .pipe(catchError(this.handleError('getOrganizationContactsById', [])));
    }

    getOrganizationDeatilsById(id: number, userName: string): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.getOrganizationDeatilsByIdURL + id + "?userName=" + userName,
            this.httpOptions)
            .pipe(catchError(this.handleError('getOrganizationDeatilsById', [])));
    }

    getOrganizationList(appId: number): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.getOrganizationListURL + "?appId=" + appId,
            this.httpOptions)
            .pipe(catchError(this.handleError('getOrganizationList', [])));
    }

    getOrganizationSearch(searchVO: SearchVO): Observable<OrganizationPriestSearchResponse> {
        return this._http.post<any>(environment.getOrganizationSearchUrl , searchVO, this.httpOptions).pipe(
            catchError(this.handleError('getOrganizationSearch()', [])));
    }
    getOrganizationbyManagerTypeHR(type: string ,username: string): Observable<OrganizationContactResponse[]> {
        return this._http.get<OrganizationContactResponse[]>(environment.getOrganizationbyManagerTypeHRUrl+type+"?username="+username+"&dateParam="+new Date().getTime(),this.httpOptions)
            .pipe(catchError(this.handleError('getOrganizationbyManagerTypeHR', [])));
    }
    getOrganizationContactByOrganizationId(id: number, userName: string): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.getOrganizationContactByOrganizationIdURL + id +"?userName=" + userName,
            this.httpOptions)
            .pipe(catchError(this.handleError('getOrganizationContactByOrganizationId', [])));
    }
    postOrganizationContact(organization: OrganizationContactVO): Observable<OrganizationContactResponse[]> {
        return this._http.post<OrganizationContactResponse[]>(environment.postOrganizationContactURL, organization, this.httpOptions).pipe(
            catchError(this.handleError('postOrganizationContact', [])));
    }
    deleteOrganizationContactById(id: number, userName: string): Observable<ApiResponse[]> {
        return this._http.get<ApiResponse[]>(
            environment.deleteOrganizationContactById + id + "?userName=" + userName+"&dateParam="+new Date().getTime(), this.httpOptions)
            .pipe(catchError(this.handleError('deleteOrganizationContactById', [])));
    }

}
